import useTranslation, { _T } from "utils/hooks/useTranslation";
import { env } from "env";
import numeral from "numeral";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";
import { boolean } from "yup";

interface ProductModalContentProps {
    data?: any
}

const ProductModalContent1: React.FC<ProductModalContentProps> = ({ data }) => {
    const { t } = useTranslation();
    const { network } = useSalesNetwork();
    let oldIsTitle = false;
    return (
        <>

            <group
                data-gap="30"
                data-text-size="medium"
                data-space-vertical="30"
                data-space-horizontal="50"
                data-height="autofit"
                data-align="start"

            >
                <group data-direction="column" data-length="350" data-justify="start" data-gap="5">
                    <group>
                        <picture data-ratio="4:3" data-radius="extra-special" data-border="">
                            <img src={data.product?.photo} alt=""></img>
                        </picture>
                    </group>

                    {
                        data.product.classe_energie &&
                        <group data-height="100">
                            <picture data-object-fit="contain"><img src={`${env.api_url}/assets/data/pictos_nrj/${data.product.classe_energie}.png`} alt="" /> </picture>
                        </group>
                    }
                </group>

                <group data-direction="column" data-length="autofit" data-justify="start">
                    <group data-wrap="no" data-space="10" data-space-vertical="10" data-gap="20" data-max-length="1440">
                        <group data-height="auto" data-length="5" data-background="main"></group>
                        <group data-length="autofit" data-gap="10">
                            <text data-color="main" data-text-size="40" data-min-height="40" data-wrap="wrap" data-max-length="fit">{data.product?.product_nom}</text>
                            <group data-align="center" data-gap="5" data-text-size="25"><text>{t("ARTICLE_CODE")} :</text><text data-weight="600">{data.product?.code_env}</text></group>
                        </group>
                    </group>

                    <space></space>
                    <group data-gap="5">
                        <group data-align="end" data-gap="20"><text>{t("DEEE_PD")}</text><text data-text-size="xx-large" data-weight="500" data-height="40">
                            {network?._parameters.hidePrice ? "-" : numeral(data.product.price).format() + " " + network?._parameters.currency} {_T("HT") ? `${_T("HT")}*` : ""}
                        </text>
                        </group>
                        {_T("HT") ? <group data-align="center" data-gap="5"><text data-text-size="14">{t("ECO_DEEE_PD", { eco: parseFloat(data.product.eco), currency: network?._parameters.currency })}</text></group> : <></>}
                    </group>


                    <space></space>

                    {data?.product?.description && <group data-gap="10" data-length="autofit" data-text-size="large">
                        <group data-gap="5">
                            {
                                data?.product?.description.split('\n').map((e: any, _: number) => {

                                    const noTitle = e.indexOf("-") === 0;
                                    let text = e.indexOf("- ") === 0 ? e.replace("- ", "") : (
                                        e.indexOf("-") === 0 ? e.replace("-", "") : e); //.replace(":", "");
                                    text = text.trim();
                                    let isBold: boolean = false;
                                    if (!noTitle && (text.indexOf(":") === text.length - 1 || text.indexOf("<b>") !== -1)) {
                                        //text = text.replace(":", "");
                                        if (text.indexOf("<b>") !== -1) {
                                            text = text.replace("<b>", "").replace("</b>", "");
                                            isBold = true;
                                        }
                                    }
                                    if (text === "") return <></>;
                                    const showLine = !noTitle && !oldIsTitle;
                                    oldIsTitle = !noTitle;
                                    return !noTitle ?//e.indexOf(":") !== -1 || index === 0 ?
                                        <>
                                            {showLine && <separator data-horizontal="" />}
                                            <group
                                                data-gap="10"
                                                data-align="start"
                                            >
                                                <text
                                                    data-wrap="wrap"
                                                    {...(isBold ? { "data-weight": "600" } : {})}
                                                //data-weight="600"
                                                >
                                                    {text}
                                                </text>
                                            </group>
                                        </>
                                        :
                                        (e ?
                                            <group
                                                data-gap="10"
                                                data-wrap="no"
                                                data-align="start"
                                            >
                                                <text data-text-size="large" data-weight="600" data-color="red" >•</text>
                                                <text data-wrap="wrap">{text}</text>
                                            </group>
                                            : <></>);
                                })
                            }

                        </group>
                    </group>}

                </group>
            </group>

        </>
    )
}

export default ProductModalContent1;